<template>
<div class="container pt-6 pl-6 pt-md-5">
  <div class="py-md-4">
  </div>
  <h2 class="font-size-2_5rem tracking-1 text-center mb-5 d-none d-md-block">NEWS</h2>
  <h2 class="d-md-none mobile-section-title text-white">NEWS</h2>

  <div v-for="article in news" :key="article.id">
    <div class="hover-sky py-2" @click="showDialog(article)">
      <div class="row">
        <div class="col-md-2 col-xl-1">
          {{ dateFormat(article.date) }}
        </div>
        <div class="col-md-3 bold mobile-title">
          {{ article.title.rendered }}
        </div>
        <div class="col-md-7 col-xl-8 text-truncate">
          {{ stripTag(article.excerpt.rendered) }}
        </div>
      </div>
    </div>
    <hr class="border-black">  
  </div>
  <b-modal v-model="modalShow" :hide-footer="true">
    <template v-slot:modal-header="{ close }" class="p-0">
      <b-button size="lg" class="px-2" variant="light" @click="close()">
        <img style="width: 21px;" src="@/assets/images/cross.svg">
      </b-button>
    </template>
    <template v-if="selectedNews">
      <h5 class="py-2">{{ selectedNews.title.rendered }}</h5>
      <div v-html="selectedNews.content.rendered">

      </div>
    </template>

  </b-modal>
</div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      news: [],
      modalShow: false,
      selectedNews: null
    }
  },
  mounted() {
    this.getNews()
  },
  computed: {
  },
  methods: {
    stripTag(html) {
      let div = document.createElement("div");
      div.innerHTML = html;
      let text = div.textContent || div.innerText || "";
      return text
    },
    dateFormat(dateString) {
      return moment(dateString).format('yyyy.MM.DD')
    },

    showDialog(article) {
      console.log(article)
      this.selectedNews = article
      this.modalShow = true
    },
    async getNews() {
      const payload = await this.axios.get(process.env.VUE_APP_API_BASE_URL + '/wp-json/wp/v2/posts')
          .catch((e) => {
            alert(e);
          });
      console.log(payload)
      if (payload.data) {
        console.log(payload.status)
        // this.$set(this, 'news', payload.data)
        this.news = payload.data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hover-sky {
  color: #fff;
  @media screen and (min-width: 768px){
    color: #333;
  }
}
.mobile-title {
  font-size: 1.5rem;
  @media screen and (min-width: 768px){
    font-size: 0.85rem;
  }
}
</style>